import { useMutation } from "@tanstack/react-query";

import { BusinessPlanApi } from "../businessPlan.api";

export const useDeleteUserAccess = ({ id }: { id: string }) => {
  return useMutation({
    mutationFn: (email: string) => BusinessPlanApi.deleteUserAccess({ id, email }),
  });
}